define( [
	"../core"
], function( jQuery ) {

// Support: Android 2.3
// Workaround failure to string-cast null input
jQuery.parseJSON = function( data ) {
	return JSON.parse( data + "" );
};

return jQuery.parseJSON;

} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/ajax/parseJSON.js
// module id = 1774
// module chunks = 0